import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Flex, Modal, Spin, Tooltip, Typography } from "antd";
import { useForm } from "antd/es/form/Form";
import _ from "lodash";
import React, { useState } from "react";
import { ContentPartFilter } from "../../../../components/content-part/ContentPartFilter";
import { PageHeader } from "../../../../components/page-header";
import { EntAnimalBreedFilter } from "../../../../models/filters/animalBreedFilter";
import { EntAnimalBreed } from "../../../../models/handBooks/animalBreed";
import { AddAnimalBreedModal } from "./AddAnimalBreedModal";
import { useAnimalBreed } from "./useAnimalBreed";
import { useTranslation } from "react-i18next";
import { useGetDataOnScroll } from "../../../../components/getDataOnScrollProps/useGetDataOnScrollProps";
import { useLazyGetAnimalBreedListQuery } from "../../../../redux/api/handBooksApi/animalBreadApi";
import i18n from "i18next";
import { FilterByNameHB } from "../../../../components/filterByNameHB/FilterByNameHB";

enum FormField {
  name
}

export const AnimalBreed = () => {
  const [form] = useForm();
  const { t } = useTranslation()
  const [modal, contextHolder] = Modal.useModal();
  const [selectedAnimalBreed, setSelectedAnimalBreed] = useState<EntAnimalBreed>(new EntAnimalBreed());
  const [showModal, setShowModal] = useState<boolean>(false);
  const { onAddAnimalBreed, onEditAnimalBreed, onDeleteAnimalBreed } = useAnimalBreed(modal, () => {
	searchHandleClick();
  })

  const [getArchiveFolders] = useLazyGetAnimalBreedListQuery();
  const {
	filter,
	fetching,
	data,
	access,
	totalItems,
	setData,
	setFetching,
	setFilter,
	scrollHandler,
	setCurrentPage
  } = useGetDataOnScroll<EntAnimalBreed, EntAnimalBreedFilter>({
	initialFilter: new EntAnimalBreedFilter(),
	query: getArchiveFolders
  });
  const [height, setHeight] = useState<number>(0);
  const openAddModal = (item: EntAnimalBreed) => {
	setSelectedAnimalBreed(item);
	setShowModal(true);
  }
  const setEntityFromFields = (): EntAnimalBreedFilter => {
	let filt: EntAnimalBreedFilter = _.clone(filter);
	filt.name = form.getFieldValue(FormField.name) ?? null;
	filt.page = 1;
	return filt;
  }
  const clearFields = () => {
	form.setFields([
	  { name: FormField.name, value: null },
	]);
  }
  const searchHandleClick = () => {
	setFilter(setEntityFromFields());
	setData([]);
	setCurrentPage(0);
	setFetching(true);
  }

  const table = (
	<div style={ { maxHeight: `${ height }px`, overflow: 'auto' } } onScroll={ scrollHandler }>
	  <table>
		<thead>
		<tr>
		  <th style={ { width: "40px" } }>#</th>
		  <th>{ t('general.nameKy') }</th>
		  <th>{ t('general.nameRu') }</th>
		  <th>{ t('population.animal_type_population') }</th>
		  <th style={ { width: "120px" } }></th>
		</tr>
		</thead>
		<tbody>
		{ fetching ?
		  <tr>
			<th colSpan={ 5 }>
			  <Spin spinning={ fetching } style={ {
				width: '100%',
				height: '180px',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center'
			  } }/>
			</th>
		  </tr>
		  : <></> }
		{ data.map((item, index) => (
		  <tr key={ item.id }>
			<td>{ ++index }</td>
			<td>{ item?.nameKy }</td>
			<td>{ item?.nameRu }</td>
			<td>{ i18n.language === 'ru' ? item.animalType?.nameRu : item.animalType?.nameKy }</td>
			<td>
			  <Flex gap="small">
				{ access && access.methodPut && (
				  <Tooltip title={ t('general.edit') }>
					<Button className='btn_edit' onClick={ () => {
					  openAddModal(item)
					} } type="primary" shape="circle" icon={ <EditOutlined/> }/>
				  </Tooltip>
				) }
				{ access && access.methodDelete && (
				  <Tooltip title={ t('general.delete') }>
					<Button className='btn_edit' danger onClick={ () => {
					  onDeleteAnimalBreed(item)
					} } type="primary" shape="circle" icon={ <DeleteOutlined/> }/>
				  </Tooltip>
				) }
			  </Flex>
			</td>
		  </tr>
		)) }
		</tbody>
	  </table>
	</div>
  );
  return (
	<>
	  <PageHeader
		title={ t('titles.animal_breeds') }
		additionalInfo={
		  <Typography.Text style={ { marginBottom: '0.5em', display: 'block' } }
						   type="secondary"> { t('general.records_found') } { totalItems }</Typography.Text>
		}/>
	  { access && access.methodPost && (
		<Button type="primary" icon={ <PlusOutlined/> } onClick={ () => {
		  openAddModal(new EntAnimalBreed)
		} }>
		  { t('handbooks.animal_breeds.add_animal_breeds') }
		</Button>
	  ) }
	  <ContentPartFilter
		filter={ <FilterByNameHB onSearch={ searchHandleClick }
									onReset={ () => {
									  clearFields();
									  searchHandleClick()
									} } formField={ FormField } form={ form }/> }
		setHeight={ setHeight }
		table={ table }

	  />
	  <AddAnimalBreedModal
		animalBreed={ selectedAnimalBreed }
		show={ showModal }
		onHide={ () => {
		  setShowModal(false)
		} }
		onSubmit={ selectedAnimalBreed.id !== 0 ? onEditAnimalBreed : onAddAnimalBreed }
	  />
	  { contextHolder }
	</>
  )
}
